var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { Platforms } from "../../utils";
import { BrazeTrackingService } from "../infrastructure/BrazeTrackingService";
import { DeviceIdRepository } from "../infrastructure/DeviceIdRepository";
import { MixpanelTrackingSerice } from "../infrastructure/MixpanelTrackingService";
var Tracker = /** @class */ (function () {
    function Tracker() {
        Object.defineProperty(this, "trackerServices", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "deviceIdRepository", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "userloggedIn", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "user", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.trackerServices = [MixpanelTrackingSerice.getInstance(), BrazeTrackingService.getInstance()];
        this.deviceIdRepository = DeviceIdRepository.getInstance();
        this.deviceIdRepository.init(Platforms.CHROME_EXTENSION);
    }
    Object.defineProperty(Tracker, "getInstance", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            if (!this.instance) {
                this.instance = new Tracker();
            }
            return this.instance;
        }
    });
    Object.defineProperty(Tracker.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.initialize()];
                        case 1:
                            _a.sent();
                            return [2 /*return*/];
                    }
                });
            });
        }
    });
    Object.defineProperty(Tracker.prototype, "initIdentified", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (user) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b, service;
                var e_1, _c;
                return __generator(this, function (_d) {
                    this.userloggedIn = true;
                    this.user = user;
                    try {
                        for (_a = __values(this.trackerServices), _b = _a.next(); !_b.done; _b = _a.next()) {
                            service = _b.value;
                            service.identify(user);
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(Tracker.prototype, "reset", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    try {
                        this.deviceIdRepository.reset();
                        this.userloggedIn = false;
                        this.user = undefined;
                    }
                    catch (err) {
                        console.error(err);
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(Tracker.prototype, "track", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (event) {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b, service;
                var e_2, _c;
                return __generator(this, function (_d) {
                    try {
                        for (_a = __values(this.trackerServices), _b = _a.next(); !_b.done; _b = _a.next()) {
                            service = _b.value;
                            service.track(event, this.user, this.userloggedIn);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    Object.defineProperty(Tracker.prototype, "initialize", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function () {
            return __awaiter(this, void 0, void 0, function () {
                var _a, _b, service;
                var e_3, _c;
                return __generator(this, function (_d) {
                    try {
                        for (_a = __values(this.trackerServices), _b = _a.next(); !_b.done; _b = _a.next()) {
                            service = _b.value;
                            service.initialize();
                        }
                    }
                    catch (e_3_1) { e_3 = { error: e_3_1 }; }
                    finally {
                        try {
                            if (_b && !_b.done && (_c = _a.return)) _c.call(_a);
                        }
                        finally { if (e_3) throw e_3.error; }
                    }
                    return [2 /*return*/];
                });
            });
        }
    });
    return Tracker;
}());
export { Tracker };
